<template>
  <v-app-bar dark app :color="$root.themeColor">
    <v-toolbar-title>
      <v-app-bar-nav-icon @click="toggleNavigationBar"></v-app-bar-nav-icon>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-dialog v-model="dialogSettings" width="700">
      <v-card>
        <v-card-title class="headline" primary-title> Settings </v-card-title>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="setUpSettings">
            Save Changes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="showResult" :timeout="2000" top>
      {{ result }}
    </v-snackbar>

    <v-menu left bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-for="n in 5" :key="n" @click="() => {}">
          <v-list-item-title>Option {{ n }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu
      class="toolbar-menu-item"
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          text
          v-bind="attrs"
          v-on="on"
          @click="notifications.map(x => (x.isActive = false))"
        >
          <v-badge
            color="secondary"
            overlap
            v-if="notifications.filter(x => x.isActive).length > 0"
          >
            <span slot="badge">
              {{ notifications.filter(x => x.isActive).length }}
            </span>
            <v-icon medium>notifications</v-icon>
          </v-badge>
          <v-icon v-else medium>notifications</v-icon>
        </v-btn>
      </template>

      <v-card class="elevation-0">
        <v-toolbar card dense color="transparent">
          <v-toolbar-title
            ><h5>You have {{ notifications.length }} new notification(s)</h5>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-list two-line class="pa-0">
            <template v-for="(item, index) in notifications">
              <v-divider :key="index" />
              <v-list-item avatar :key="item.title" @click="item.onClick">
                <v-list-tile-avatar :color="item.color">
                  <v-icon dark>{{ item.icon }}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-sub-title
                    v-html="item.title"
                  ></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action class="caption">
                  {{ item.actionAt }}
                </v-list-tile-action>
              </v-list-item>
            </template>
          </v-list>
          <v-divider></v-divider>
          <v-btn block text v-if="false">See all notifications</v-btn>
          <v-divider></v-divider>
        </v-card-text>
      </v-card>
    </v-menu>

    <v-menu
      class="toolbar-menu-item"
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          large
          slot="activator"
          text
          :ripple="false"
        >
          <v-avatar size="42px">
            <img
              :src="
                user.avatar === null
                  ? require(`@/assets/images/user-avatar.png`)
                  : user.avatar
              "
            />
          </v-avatar>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item-group color="primary">
          <v-list-item>
            <v-list-item-icon>
              <v-icon v-text="'account_circle'"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Profile'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon v-text="'settings'"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Settings'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon v-text="'exit_to_app'"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Logout'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
import { mapState } from "vuex";
import Vue from 'vue';
import VueCookie from 'vue-cookie';
export default {
  data() {
    return {
      rating: null,
      dialog: false,
      dialogSettings: false,
      switchEmailNotification: true,
      showPassword: null,
      showPasswordConfirm: null,
      userEmail: null,
      password: null,
      passwordConfirm: null,
      error: false,
      showResult: false,
      result: "",
      items: [
        {
          icon: "account_circle",
          href: "#",
          title: "Profile",
          click: e => {}
        },
        {
          icon: "settings",
          href: "#",
          title: "Settings",
          click: () => {
            const vm = this;

            vm.dialogSettings = true;
          }
        },
        {
          icon: "exit_to_app",
          href: "#",
          title: "Log Out",
          action: "logout",
          click: () => {
            const vm = this;

            vm.$router.push({ name: "Login" });
          }
        }
      ],
      notifications: [
        {
          title: "New mail from Adam Joe",
          color: "light-blue",
          icon: "email",
          actionAt: "12 min ago",
          isActive: true,
          onClick: () => {
            const vm = this;

            vm.$router.push({ name: "Mailbox" });
          }
        },
        {
          title: "Scheculed meeting",
          color: "red",
          icon: "calendar_today",
          actionAt: "46 min ago",
          isActive: true,
          onClick: () => {
            const vm = this;

            vm.$router.push({ name: "Calendar" });
          }
        },
        {
          title: "New mail from Github",
          color: "light-blue",
          icon: "email",
          isActive: true,
          timeLabel: "2 hour ago",
          onClick: () => {
            const vm = this;

            vm.$router.push({ name: "Mailbox" });
          }
        }
      ],
      languages: [
        {
          name: "English",
          languageCode: "en",
          path: require("../../assets/flags/en.png")
        },
        {
          name: "Turkish",
          languageCode: "tr",
          path: require("../../assets/flags/tr.png")
        },
        {
          name: "French",
          languageCode: "fr",
          path: require("../../assets/flags/fr.png")
        },
        {
          name: "German",
          languageCode: "de",
          path: require("../../assets/flags/de.png")
        },
        {
          name: "Japanese",
          languageCode: "ja",
          path: require("../../assets/flags/ja.png")
        },
        {
          name: "Simplified Chinese",
          languageCode: "ch",
          path: require("../../assets/flags/ch.png")
        }
      ]
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    selectedLanguageFlag() {
      const vm = this;

      switch (vm.$i18n.locale) {
        case "en":
          return require("../../assets/flags/en.png");
        case "tr":
          return require("../../assets/flags/tr.png");
        case "fr":
          return require("../../assets/flags/fr.png");
        case "de":
          return require("../../assets/flags/de.png");
        case "ja":
          return require("../../assets/flags/ja.png");
        case "ch":
          return require("../../assets/flags/ch.png");
      }
    }
  },
  methods: {
    logout() {
      Vue.prototype.$axios.defaults.headers.common.Authorization = null;
      VueCookie.delete('token');
      this.$router.push({name: 'Login'});
    },
    toggleNavigationBar() {
      const vm = this;

      vm.$emit("toggleNavigationBar");
    },

    setUpSettings() {
      const vm = this;

      if (
        vm.userEmail === null ||
        vm.password === null ||
        vm.passwordConfirm === null
      ) {
        vm.result = "Email and Password can't be null.";
        vm.showResult = true;

        return;
      }

      if (vm.password !== vm.passwordConfirm) {
        vm.error = true;
        vm.result = "Passwords does not match the confirm password.";
        vm.showResult = true;

        return;
      }

      vm.$root.userEmail = vm.userEmail;
      vm.$root.userPassword = vm.password;

      vm.result = "Email and password changed successfully.";
      vm.showResult = true;

      vm.dialogSettings = false;
    },

    selectLanguage(code) {
      const vm = this;

      vm.$root.setLanguage(code);
    }
  }
};
</script>
<style>
.toolbar-menu-item {
  padding-left: 5px;
}

.selected-language-flag {
  max-width: 45px;
}

.language-flag {
  max-width: 40px;
}

.languages-list-item {
  cursor: pointer;
  margin-top: -2px;
  margin-left: 1px;
}

.languages-list-item-title {
  font-size: 16px;
}

.languages-list-item-title:hover {
  color: #41b883;
  font-weight: bold;
}
.language-menu {
  border-radius: 25px;
  width: 235px;
  margin-right: 10px;
}
.v-badge__badge {
  color: #4c5454 !important;
}
</style>
